import React from 'react'

import { useWatch } from 'react-hook-form'

import { FormTextField } from 'components/input'

// Echoes the number with grouping, so an extra zero shows before it is saved.
const RevealApiLimitField = ({ name }: { name: string }) => {
  const value = useWatch({ name })

  return (
    <FormTextField
      helperText={value === '' || value == null ? undefined : Number(value).toLocaleString()}
      name={name}
      type="number"
    />
  )
}

export default RevealApiLimitField
